export default {
  harassment: {
    create: {
      ingress:
        'Here you have the opportunity to tell us more about what you have witnessed or experienced at {organizationTitle}. We are very grateful for your help in keeping our workplace safe.',
      instructions:
        "Write your report in the text area below. You decide wether to include your email address with the report, or to remain anonymous. Regardless if you're anonymous or not it's possible to come back and follow up on your case after submitting the report.",
      instructions1:
        "You will receive confirmation that the report is sent, a case id and password which you can use, regardless if you're anonymous or not, to later come back and follow-up on the case.",
      instructions2:
        "Reports will be received by appointed administrators at {organizationTitle}. No-one else can read the report you sent. If you entered an email-adress you will be notified when the case changes status and if there are questions from the organisation to you. We will then handle your identity with confidentiality and won't reveal it unless necessary for the case.",
      instructionsHeader: 'How does it work?',
      options: {
        confirmNotToIncludeEmail:
          'I understand that by not including my email address, I waive the opportunity to be notified when the status of my case changes and the recieving organization does not know who I am.',
        includeEmail: 'I want to include my email address'
      }
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'After you submit the report, you will no longer be able to read or make changes for security reasons. However, you can come back later and follow the status of the case, see any follow-up questions from {organizationTitle} and yourself, anonymously, fill in with further information.',
        confirmDescriptionEmailIncluded:
          'Since you have selected to include your email, we will contact {email} when the case is opened and if we have any questions for you. Please check your report below before you submit it.',
        confirmDescriptionEmailNotIncluded:
          'You have selected not to include an email address with the report, so we will not be able to contact you. Check the report below before you submit it.',
        createDescription: 'Please write your desciption here:',
        placeholder: 'I would like to report...',
        reporterGuide: {
          question1: 'What is your concern?',
          question2: 'When did this happen?',
          question3: 'Who were involved?',
          question4: 'Where did it happen?',
          question5: 'Did you include all the details?',
          question6: 'You can add an image if you want',
          title: 'Guide for writing a report'
        },
        responseDescriptionEmailIncluded:
          'You will receive an email notification when the case is opened by an administrator.'
      }
    },
    title: 'Report to {organizationTitle}'
  },
  whistleblower: {
    alerts: {
      notValidLink: ' Please follow a valid link to go here.'
    },
    buttons: {
      back: 'Go back',
      continue: 'Continue',
      noOption: 'No',
      send: 'Send report',
      yesOption: 'Yes'
    },
    confirm: {
      title: {
        reportNotSent: 'Report NOT sent!'
      }
    },
    create: {
      email: {
        help: 'If you choose to include an email with your report we will get back to you about status updates or if we have any questions. Adding an email address is voluntary.',
        label: 'Email',
        placeholder: 'Please enter your email here'
      },
      ingress:
        'Here you have the opportunity to report misconduct that you are aware of, or suspect, has happened or will happen at {organizationTitle}. The channel is only to be used to report about misconduct in work related situations and only if you have reason to suspect that your information is true.',
      instructions:
        "First you select how you want to leave your report. You can also decide wether to include your email address with the report, or to remain anonymous. Regardless if you're anonymous or not it's possible to come back and follow up on your case after submitting the report.",
      instructions1:
        "Then you will receive confirmation that the report is sent, a case id and password which you can use, regardless if you're anonymous or not, to later come back and follow-up on the case. Even if you choose to report via physical meeting or phone call you can also follow-up the case digitally if you want.",
      instructions2:
        "Reports will be received by appointed administrators at {organizationTitle}. No-one else can read the report you sent. If you entered an email-adress you will be notified when the case changes status and if there are questions from the organisation to you. We will then handle your identity with confidentiality and won't reveal it unless necessary for the case.",
      instructionsHeader: 'How does it work?',
      options: {
        confirmNotToIncludeEmail:
          'I understand that by not including my email address, I waive the opportunity to be notified when the status of my case changes as the recieving organization does not know who I am.',
        includeEmail: 'I want to include my email address'
      }
    },
    followup: {
      buttons: {
        submit: 'Fetch case'
      },
      messages: {
        buttons: {
          send: {
            help: 'You can send a follow up message that will be read by representatives of the receiving organization. Noone else can read your message.',
            title: 'Send message'
          }
        },
        messageSent: 'Thanks for your message!',
        placeholder: 'Type a message here',
        reporter: 'Reporter',
        title: 'Messages',
        writtenByAdmin: 'Admin'
      },
      status: {
        new: {
          description:
            'Your report has been received and will be reviews shortly.',
          title: 'New'
        },
        open: {
          description:
            'Your report has received and is currently being reviewed. Please check back later for further updates. If you have provided contact information we’ll get in touch.',
          title: 'Open'
        },
        solved: {
          description:
            'Your report has been handled and the investigation is now completed. If you have provided contact information we will get back you with  additional details.',
          title: 'Solved'
        }
      },
      statusLabel: 'The case has status:',
      title: 'Case {caseName}'
    },
    followupLogin: {
      caseLabel: 'Case ID',
      passwordLabel: 'Password',
      title: 'Follow up on case'
    },
    messages: {
      error: {
        failedToSendReport: 'Could not send the report',
        organizationNotFound:
          'We could not find an organization to send your report to. Please make sure that you followed a valid link to get here.',
        whistleblowerInfoNotFound:
          'Could not find information for reporting in this organizaion'
      }
    },
    received: {
      bottomWarning:
        'Notice! This is the only opportunity for you to see the information above, so do save it now!',
      caseLabel: 'Case ID',
      linkLabel: 'Link',
      passwordLabel: 'Password',
      thankyouTitle: 'Thank you',
      title: 'Report received!',
      topWarning: 'Please safely store and securely the information below!'
    },
    reportingChannels: {
      digitalReport: {
        confirmDescription:
          'After you submit the report, you will no longer be able to read or make changes for security reasons. However, you can come back later and follow the status of the case, see any follow-up questions from {organizationTitle} and yourself, anonymously, fill in with further information.',
        confirmDescriptionEmailIncluded:
          'Since you have selected to include your email, we will contact {email} when the case is opened and if we have any questions for you. Please check your report below before you submit it.',
        confirmDescriptionEmailNotIncluded:
          'You have selected not to include an email address with the report, so we will not be able to contact you. Check the report below before you submit it.',
        createDescription:
          'Describe what has happened and why you want to report this. Do not include personal information unless it is relevant to the case.',
        label: 'I want to report digitally via this form',
        placeholder: 'I would like to report...',
        reporterGuide: {
          question1: 'What is your concern?',
          question2: 'When did this happen?',
          question3: 'Who were involved?',
          question4: 'Where did it happen?',
          question5: 'Did you include all the details?',
          question6: 'You can add an image if you want',
          title: 'Guide for writing a report'
        },
        responseDescriptionEmailIncluded:
          'You will receive an email notification when the case is opened by any of the administrators. This will happen within 7 days. After the case is opened we will complete the investigation within 3 months.',
        responseDescriptionEmailNotIncluded:
          "Since you have selected to report anonymously you have declined to receieve an email notification when the case is opened. You will also not be notified about other case activity. By using the details below it's still possible for you to get back and follow the case status.",
        responseIngress:
          'Thanks for your report! We will handle your case as soon as possible.'
      },
      phoneCall: {
        confirmDescription:
          'At the next step you will be presented with a phone number to call. Are you sure you want to continue with report via a phone call?',
        createDescription:
          'You will get the opportunity to enter your report as a voice message.',
        label: 'I want to submit the report through a phone call',
        message:
          '=== Reporter will call and leave the report as a voice message. ===',
        responseDescription:
          'In order to leave your report please call the following phone number and leave a voice message:',
        responseInstructions1: 'Call the phone number above',
        responseInstructions2: 'Leave your report as detailed as possible',
        responseInstructions3:
          'If you want to be notified about case status changes or new correspondence, mention your email address or phone number in the report.',
        responseInstructions4:
          'Save the below information so that you can go back and follow up here.',
        responseInstructionsHeader: 'Instructions',
        responseTitle: 'Report via phone call',
        responseWarning:
          'If you have not left a voice message within 7 days your case will be automatically closed.'
      },
      physicalMeeting: {
        confirmDescription:
          'We will contact you at {email} regarding your request to report via a physical meeting. Do you want to continue?',
        createDescription:
          'We offer you the opportunity to leave your report in a physical meeting. In order to do so you must enter an email address that we will use to contact you in order to schedule a meeting.',
        label: 'I want to submit the report in a phyiscal meeting',
        message:
          '=== Reported requested a physical meeting to submit the report. ===',
        responseDescription:
          'Thank you! We will get back to you with a proposal for when we can have a physical meeting where you leave your report.  Please make sure to save the following information. You will need to use it if you after the meeting want to follow up on your case.',
        responseTitle: 'Meeting request sent'
      }
    },
    title: 'Report misconduct at {organizationTitle}'
  }
}
